<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top border menuName="修改昵称" prevUrl="/WeChat/Person/Info">
			<Button :disabled="person.palias==palias" class="slot" style="margin-top: -2px;" type="success" >保存</Button>
		</Layout-Top>
		<Row type="flex" justify="center" align="center">
			<Col span="1">
			</Col>
			<Col span="22" style="font-size: 16px;">
				<input  v-model="palias" style="background: #eceef1;height: 36px;width: 100%;border-bottom:1px solid #aCCaCC ;border-top: none;border-left: none;border-right: none;outline: none;" type="text" />
			</Col>
			<Col span="1">
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center"  style="color: #CCCCCC;margin-top: 8px;">
			<Col span="1">
			</Col>
			<Col span="22">
				好名字，好心情
			</Col>
			<Col span="1">
			</Col>
		</Row>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return{
				person:{
					palias:'有心人。'
				},
				palias:'有心人。'                            
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Info/Alias/index.vue